import React, {useEffect} from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import grey from '@material-ui/core/colors/grey';
import teal from '@material-ui/core/colors/teal';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import WarningIcon from '@material-ui/icons/Warning'
import { Select, MenuItem, FormControl, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useToken from '../../useToken';
import { useSelector, useDispatch } from 'react-redux';
import { fetchData } from '../../features/cultivation_models/cultivationModelSlice';
import { updateData } from '../../features/cultivation_models/cultivationUpdateSlice';
import { deleteData } from '../../features/cultivation_models/cultivationDeleteSlice';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: grey[400],
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
  },
  paper: {
    border: '1px solid',
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  textfield: {
    '& > *': {
      margin: theme.spacing(1),
      width: '10ch',
    },
  },
  modeltextfield: {
    '& > *': {
      margin: theme.spacing(1),
      width: '50ch',
    },
  },
  addicon: {
    color: teal[700],
  },
  delicon: {
    color: red[500],
  },
  formControl: {
    margin: 10,
    marginLeft: 30,
    minWidth: 300,
  },
  dialogformControl: {
    margin: 5,
    marginLeft: 15,
    marginRight: 15,
    minWidth: 300,
  },
}));

const getOrderedTasks = (tasks, order) => {
  var orderedMap = []
  order.forEach (
    (action) => {
      tasks.forEach (
        (task) => {
          if (task.Task === action) {
            orderedMap.push(task)
          }
        }
      )
    }
  )
    return orderedMap
}

const getDayPLDMap = (tasks) => {
  var DayPLDMap = {}
  tasks.forEach(
    (task) => {
      if (task.Value === -1) {
        DayPLDMap[task.Task] = 0
      } else {
        DayPLDMap[task.Task] = task.Value
      }
    }
  )
  return DayPLDMap
}

const getSelectedMap = (tasks) => {
  var selectedMap = {}
  tasks.forEach(
    (task) => {
      if (task.Value === -1) {
        selectedMap[task.Task] = true
      }
    }
  )
  return selectedMap
}

const getAvailableOrder = (tasks, order) => {
  var availableOrder = []
  var taskList = tasks.map(
    (task) => {
      return task.Task
    }
  )
  availableOrder = order.filter(
    (action) => {
      if (!(taskList.includes(action))) {
        return action
      }
    }
  )
  return availableOrder
}

const CultivationView = (props) => {
  const {token, setToken} = useToken()
  const dispatch = useDispatch()
  const [orderedTasks, setOrderedTasks] = React.useState([])
  const [dayPLDValue, setDayPLDValue] = React.useState({})
  const [selectedActions, setSelectedActions] = React.useState({})
  const [updateOpen, setUpdateOpen] = React.useState(false);

  const {models, crop, model} = props.data
  const data = models.data || []
  const order = models.order || []

  var filteredRows = data.filter(function(item) {
    if (item.Model === model && item.Crop === crop) {
      return item
    }
  }) 

  var tasks = filteredRows.flatMap(
    (model) => { 
      return model.Tasks
  }) || []

  const availableOrder = getAvailableOrder(tasks, order)

  useEffect(()=> {
    setOrderedTasks(getOrderedTasks(tasks, order))
    setDayPLDValue(getDayPLDMap(tasks))
    setSelectedActions(getSelectedMap(tasks))
  }, [crop, dispatch])

  const classes = useStyles();

  const setDayPLD = (task, val) => {
    let dayPLD = {...dayPLDValue}
    dayPLD[task] = val
    setDayPLDValue(dayPLD)
  }

  const setSelectedState = (val) => {
    let selected = {...selectedActions}
    selected[val] = true
    setSelectedActions(selected)
  }

  const removeSelectedState = (val) => {
    let selected = {...selectedActions}
    selected[val] = false
    setSelectedActions(selected)
  }

  const PLDView = (props) => {
    const [task, setTask] = React.useState(props.task)

    const handleChange =(event) => {
      if (event.target.value < 0) {
        alert("Day from Plant Date should be more than 0!")
        setDayPLD(task, 0)
      } else if (event.target.value > 49) {
        alert("Day from Plant Date should be less than 50!")
        setDayPLD(task, 49)
      } else {
        setDayPLD(task, event.target.value)
      }
    }
    return (
      <form className={classes.textfield} autoComplete="off">
          <TextField
          id="standard-number"
          type="number"
          value={dayPLDValue[task]}
          disabled={selectedActions[task]}
          onChange={handleChange}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </form>
  )  
}

  const PLDSwitch = withStyles({
    switchBase: {
      '&$checked': {
        color: teal[500],
      },
      '&$checked + $track': {
        backgroundColor: teal[500],
      },
    },
    checked: {},
    track: {},
  })(Switch);

  const SwitchView = (props) => {
    const [task, setTask] = React.useState(props.task)
    const [checked, setChecked] = React.useState(props.checked)
    const handleChange =(event) => {
      if (event.target.checked) {
        console.log("checked")
        setSelectedState(task)
      } else {
        console.log("unchecked")
        removeSelectedState(task)
      }
    }
    return (
     <FormControlLabel
        control={
          <PLDSwitch
            checked={selectedActions[task]}
            onChange={handleChange}
            name={task}
            color="primary"
          />
        }
        label="Daily"
      />
    )
  }

  const ActionView = (props) => {
    const [action, setAction] = React.useState(props.action)
    const handleAction = (event) => {
      setAction(event.target.value)
    }

    return (
        <FormControl className={classes.formControl}>
         <Select
          labelId="action-label"
          id="action"
          value={action}
          onChange={handleAction}
         >
          { 
              order.map((task) => {
                return <MenuItem value={task}>{task}</MenuItem>
              }  
          )}
        </Select>
        </FormControl>
    )
  }


  const TasksView = () => {
    const [open, setOpen] = React.useState(false);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [deletedTask, setDeletedTask] = React.useState("");

    const handleOpen = task => {
      setOpen(true);
      console.log("handleOpen")
      console.log(task)
    };

    const handleDeleteOpen = task => {
      setDeleteOpen(true)
      setDeletedTask(task)
      console.log(task)
    };

    const handleClose = () => {
      setOpen(false);
    };

    const handleDeleteClose = () => {
      setDeleteOpen(false);
    };

    const DialogView = (props) => {
      const [selectedTask, setSelectedTask] = React.useState();
      const [selectedDPLD, setSelectedDPLD] = React.useState(0);
      const [selectedDaily, setSelectedDaily] = React.useState(false);

      const handleAction = (event) => {
        setSelectedTask(event.target.value)
      }

      const handleDPLD =(event) => {
        if (event.target.value < 0) {
          alert("Day from Plant Date should be more than 0!")
          setSelectedDPLD(0)
        } else if (event.target.value > 49) {
          alert("Day from Plant Date should be less than 50!")
          setSelectedDPLD(49)
        } else {
          setSelectedDPLD(event.target.value)
        }
      }

      const handleAddTask = () => {
        dispatch(updateData({token, model, crop, selectedTask, 
          selectedDPLD, selectedDaily}))
        dispatch(fetchData({token}))
        setOpen(false);
      }

      const handleSwitch =(event) => {
        if (event.target.checked) {
          setSelectedDaily(true)
        } else {
          setSelectedDaily(false)
        }
      }

      return (
        <Dialog open={open} fullWidth={true}
                onClose={handleClose} 
                aria-labelledby="form-dialog-title"
                PaperProps={{
                  style: {
                    boxShadow: 'none',
                  },
                }}
                BackdropProps={{
                  style: {
                    backgroundColor: 'rgba(0,0,0,0.1)',
                  },
                }}
                >
        <DialogTitle id="form-dialog-title">Add Farming Task</DialogTitle>
        <Grid container>
        <Grid xs={8}>
          <FormControl className={classes.dialogformControl}>
          <Select
          labelId="action-label"
          value={selectedTask}
          onChange={handleAction}
          id="action"
         >
          { 
              availableOrder.map((task) => {
                return <MenuItem value={task}>{task}</MenuItem>
              }  
          )}
        </Select>
        <FormHelperText>select a task</FormHelperText>
        </FormControl>
        </Grid>
        <Grid xs={4} >
         <form className={classes.textfield} autoComplete="off">
          <TextField
          id="standard-number"
          type="number"
          onChange={handleDPLD}
          value={selectedDPLD}
          disabled={selectedDaily}
          InputLabelProps={{
            shrink: true,
          }}
        />
        </form>
           <FormControlLabel
        control={
          <PLDSwitch
            color="primary"
            checked={selectedDaily}
            onChange={handleSwitch}
          />
        }
        label="Daily"
        />
        </Grid>
        </Grid>
        <DialogActions>
          <Button onClick={handleClose} color={teal[500]}>
            Cancel
          </Button>
          <Button onClick={handleAddTask} color={teal[500]}>
            Update
          </Button>
        </DialogActions>
      </Dialog>
      )
    }

    const DeleteDialogView = (props) => {
      return (
        <Dialog open={deleteOpen} fullWidth={true}
                onClose={handleDeleteClose} 
                aria-labelledby="form-dialog-title"
                PaperProps={{
                  style: {
                    boxShadow: 'none',
                  },
                }}
                BackdropProps={{
                  style: {
                    backgroundColor: 'rgba(0,0,0,0.1)',
                  },
                }}
                >
      <DialogTitle id="form-dialog-title">Delete Farming Task : {deletedTask}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleDeleteClose} color={teal[500]}>
            Cancel
          </Button>
          <Button onClick={handleDeleteTask} color={red[500]}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      )
    }

    const handleDeleteTask = () => {
      dispatch(deleteData({token, model, crop, deletedTask}))
      dispatch(fetchData({token}))
      setDeleteOpen(false);
    }

    var tasksview = orderedTasks.map (
      (task, index) => {
        return (
          <StyledTableRow key={task.Task}>
            <StyledTableCell>
              <Icon className={classes.addicon} 
                onClick={()=>handleOpen(task.Task)}>add_circle
              </Icon>
              <DialogView/>
            </StyledTableCell>
            <StyledTableCell>
              <Icon className={classes.delicon}
                onClick={()=>handleDeleteOpen(task.Task)}>remove_circle
              </Icon>
              <DeleteDialogView/>
            </StyledTableCell>
            <StyledTableCell/>
            <StyledTableCell>
              <ActionView action={task.Task}/>
            </StyledTableCell>
            <StyledTableCell/>
            <StyledTableCell align="center">
              <div>
              <PLDView task={task.Task} pld={task.Value}/>
              <SwitchView task={task.Task} pld={task.Value}/>
              </div>
            </StyledTableCell>
          </StyledTableRow>
        )
      }
    )
    return tasksview    
  }

  const handleUpdate = (event) => {
    let payload = {
      'Daily': selectedActions,
      'DayFromPLD': dayPLDValue,
      'Tasks': orderedTasks,
    }
    orderedTasks.forEach(
      (task) => {
        if (dayPLDValue[task.Task] != task.Value) {
          if (task.Value == -1) {
            if (selectedActions[task.Task] == false) {
              let selectedTask = task.Task
              let selectedDPLD = dayPLDValue[task.Task]
              let selectedDaily = selectedActions[task.Task]
              dispatch(updateData({token, model, crop, selectedTask, 
                selectedDPLD, selectedDaily}))
            }
          } else {
            let selectedTask = task.Task
            let selectedDPLD = dayPLDValue[task.Task]
            let selectedDaily = false
            dispatch(updateData({token, model, crop, selectedTask, 
              selectedDPLD, selectedDaily}))
          }
        }
      }
    )
    for (const daily in selectedActions) {
      orderedTasks.forEach(
        (task) => {
            if (daily === task.Task) {
              if (task.Value != -1) {
                let selectedTask = task.Task
                let selectedDPLD = selectedActions[task.Task]
                let selectedDaily = selectedActions[daily]
                dispatch(updateData({token, model, crop, selectedTask, 
                  selectedDPLD, selectedDaily}))
              }
            }
          }
      )
    }
    
    dispatch(fetchData({token}))
  }

  const GreenButton = withStyles((theme) => ({
    root: {
      marginTop: 15,
      width: "20ch",
      color: "#fff",
      backgroundColor: green[500],
      '&:hover': {
        backgroundColor: green[700],
      },
    },
  }))(Button);

  const UpdateButton = () => {
    return (
      <GreenButton onClick={handleUpdateOpen}>Update</GreenButton>
    )
  }

  const handleUpdateClose = () => {
    setUpdateOpen(false)
    dispatch(fetchData({token}))
  }

  const handleUpdateOpen = () => {
    setUpdateOpen(true)
  }

  const UpdateDialogView = () => {
    return (
      <Dialog open={updateOpen} fullWidth={true}>
        <DialogTitle> Are you sure you want to modify the Cultivation Model?</DialogTitle>
        <DialogContent>
          <Typography variant="body1" style={{color: red[500]}}>
            <WarningIcon/> Changing the values may affect the Automation process!
          </Typography>
        </DialogContent>
        <DialogActions>
        <Button onClick={handleUpdateClose} color={teal[500]}>
          Cancel
        </Button>
        <Button onClick={handleUpdate} color={teal[500]}>
          Update
        </Button>
      </DialogActions>
      </Dialog> 
    )
  }

  return (
    <React.Fragment>
      <UpdateDialogView/>
      <Grid container>
        <Grid xs={10}>
          <FormControl className={classes.modeltextfield}>
            <TextField variant="outlined" value={model} />
          </FormControl>
        </Grid>
        <Grid xs>
          <UpdateButton className={classes.updateButton} />
        </Grid>
      </Grid>
      <TableContainer component={Paper}>
        <Table className={classes.table}>
        <TableHead>
          <TableRow>
          <StyledTableCell></StyledTableCell>
          <StyledTableCell></StyledTableCell>
          <StyledTableCell/>
          <StyledTableCell>Farming Type</StyledTableCell>
          <StyledTableCell/>
          <StyledTableCell>Day from Plant Date</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TasksView/>
        </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
}

export default CultivationView